var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',{staticClass:"pa-0"},[_c('router-view')],1),(_vm.$validator.DataValid(_vm.copyright))?_c('v-footer',{staticClass:"px-0 d-flex justify-center",attrs:{"app":"","inset":"","color":"transparent","height":"56"}},[_c('span',{staticClass:"copyright"},[_vm._v(_vm._s(_vm.copyright))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }